import { css } from "@emotion/react";
import styled from "@emotion/styled";

import { BaseEntityLink } from "shared/components/common/base-entity-link";
import { fontRobotoCondensed, theme } from "shared/lib/styles";

import { EntityLink } from "scmp-app/components/entity-link";

export const HeaderAllMenuItemLinkCss = css`
  color: #333333;
  font-size: 14px;
  font-family: ${fontRobotoCondensed};
  line-height: normal;

  &:hover {
    color: #2c4692;
    text-decoration: underline;
  }
  ${theme.breakpoints.up("mediumDesktop")} {
    font-size: 15px;
  }
`;

export const HeaderAllMenuItemLink = styled(EntityLink)`
  ${HeaderAllMenuItemLinkCss}
`;

export const HeaderAllMenuItemBaseLink = styled(BaseEntityLink)`
  ${HeaderAllMenuItemLinkCss}
`;
